"use strict";
export const getGlobalConfig = () => {
  var _a, _b;
  return {
    googleApiKey: ((_a = window.scoutConfig) == null ? void 0 : _a.googleApiKey) || null,
    host: ((_b = window.scoutConfig) == null ? void 0 : _b.host) || null
  };
};
